import { render, staticRenderFns } from "./RegistrationViewEN.vue?vue&type=template&id=566a681d&scoped=true"
import script from "./RegistrationViewEN.vue?vue&type=script&lang=js"
export * from "./RegistrationViewEN.vue?vue&type=script&lang=js"
import style0 from "./RegistrationViewEN.vue?vue&type=style&index=0&id=566a681d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a681d",
  null
  
)

export default component.exports